import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureKey } from '../cobrowse/reducers/feature-key';
import { genesysCloudCobrowseReducer } from './reducers/genesys-cobrowse.reducers';

@NgModule({
  imports: [StoreModule.forFeature(featureKey, genesysCloudCobrowseReducer)]
})
export class GenesysCloudCobrowseModule {}
